export const permissionsTypes = {
  A_ANOP_VIEW_ROLES_MANAGEMENT: 'A_ANOP_VIEW_ROLES_MANAGEMENT',
  CA_VIEW_DOSSIER: 'CA_VIEW_DOSSIER',
  CA_SEARCH_ORDER_ITEMS: 'CA_SEARCH_ORDER_ITEMS',
  CA_VIEW_LEADERBOARD: 'CA_VIEW_LEADERBOARD',
  CA_VIEW_RATING_COVERAGE: 'CA_VIEW_RATING_COVERAGE',
  CA_VIEW_RECENT_RATINGS: 'CA_VIEW_RECENT_RATINGS',
  CA_VIEW_RECENT_DOSSIER: 'CA_VIEW_RECENT_DOSSIER',
  CA_RSR_CONFIG: 'CA_RSR_CONFIG',
  SSO_MASTER_PASSWORD: 'SSO_MASTER_PASSWORD',
  SSO_VIEW_USER_ANALYST_DATA: 'SSO_VIEW_USER_ANALYST_DATA',
  SSO_VIEW_ORGANISATIONS_LIST: 'SSO_VIEW_ORGANISATIONS_LIST',
};
